import CardBorderHeading, { CardBorderHeadingProps } from './CardBorderHeading';

export default CardBorderHeading;
export type { CardBorderHeadingProps };
